import React, { useEffect, useRef, useState } from "react";
import { Search, ArrowRight, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PLACEHOLDER_EXAMPLES = [
  "travelai.com",
  "neuralforge.ai",
  "ledgerflow.io",
  "stayloop.io",
  "promptyard.com",
  "agentmesh.ai",
  "vaultpay.co",
  "swiftcart.com",
  "tenmin.app",
  "homeyard.com",
  "ownedbrand.com",
  "concierge.dev",
];

export default function HeroSearch({ size = "lg" }) {
  const [value, setValue] = useState("");
  const [phIndex, setPhIndex] = useState(() => Math.floor(Math.random() * PLACEHOLDER_EXAMPLES.length));
  const [phVisible, setPhVisible] = useState(true);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const id = setInterval(() => {
      // Brief fade then swap
      setPhVisible(false);
      setTimeout(() => {
        setPhIndex((i) => (i + 1) % PLACEHOLDER_EXAMPLES.length);
        setPhVisible(true);
      }, 220);
    }, 2400);
    return () => clearInterval(id);
  }, []);

  const submit = (e) => {
    e?.preventDefault?.();
    const v = value.trim();
    if (!v) return;
    navigate(`/compare?name=${encodeURIComponent(v)}`);
  };

  const inputCls =
    size === "lg"
      ? "h-16 text-lg md:h-[68px] md:text-xl"
      : "h-12 text-base";

  const placeholder = `Try: ${PLACEHOLDER_EXAMPLES[phIndex]}`;

  return (
    <form onSubmit={submit} className="relative w-full" data-testid="hero-search-form">
      <div className="glass relative flex items-center rounded-2xl px-5">
        <Search className="h-5 w-5 text-zinc-400" />
        <div className="relative flex-1">
          <input
            ref={inputRef}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            className={`peer w-full bg-transparent px-3 tabular-nums outline-none placeholder:text-zinc-400 ${inputCls} ${phVisible ? "placeholder:opacity-100" : "placeholder:opacity-0"}`}
            style={{ transition: "color 200ms" }}
            data-testid="hero-search-input"
            autoComplete="off"
          />
        </div>
        <button
          type="submit"
          className="hidden md:inline-flex items-center gap-1.5 rounded-xl bg-zinc-900 px-5 py-3 text-sm font-medium text-white transition-all hover:-translate-y-0.5 hover:bg-zinc-800"
          data-testid="hero-search-submit"
        >
          Search <ArrowRight className="h-4 w-4" />
        </button>
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-2 md:hidden">
        <button
          type="submit"
          className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-zinc-900 px-5 py-3 text-sm font-medium text-white"
        >
          Compare prices <ArrowRight className="h-4 w-4" />
        </button>
      </div>
      <div className="mt-5 hidden flex-wrap items-center gap-3 md:flex">
        <button
          type="submit"
          className="inline-flex items-center gap-1.5 rounded-xl bg-zinc-900 px-5 py-2.5 text-sm font-medium text-white transition-all hover:-translate-y-0.5 hover:bg-zinc-800"
          data-testid="cta-compare"
        >
          Compare prices
        </button>
        <button
          type="button"
          onClick={() => navigate("/ai-finder")}
          className="inline-flex items-center gap-1.5 rounded-xl border border-zinc-200 bg-white px-5 py-2.5 text-sm font-medium text-zinc-900 transition-all hover:border-indigo-200 hover:bg-indigo-50/60 hover:text-indigo-700"
          data-testid="cta-ai"
        >
          <Sparkles className="h-4 w-4" /> Generate AI names
        </button>
      </div>
    </form>
  );
}
